const GOOGLE_ANALYTICS_PAGE_NAME_MAPPING = {
  fyd: 'search-dealer',
  ddp: 'dealer',
  fyc: 'search-car',
  vdp: 'dealer',
  markt_lnd: 'dealer'
};
const pageNameTransformer = pageName => GOOGLE_ANALYTICS_PAGE_NAME_MAPPING[pageName];
export default pageNameTransformer;